//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from 'vuex';
import { cloneDeep } from 'lodash';

import AppContainer from '../../../layout/AppContainer.vue';
import TeamForm from './form/team/TeamForm.vue';
import MemberGender from './form/MemberGender.vue';
import MemberHeight from './form/MemberHeight.vue';
import MemberWeight from './form/MemberWeight.vue';
import MemberBirthDate from './form/MemberBirthDate.vue';
import MemberLastName from './form/MemberLastName.vue';
import MemberFirstName from './form/MemberFirstName.vue';
import ErrorDisplay from '../../../common/ErrorDisplay.vue';
import InformationIcon from '../../../common/icons/InformationIcon.vue';
import IntroUtils from '../../../../lib/introUtils';
import profileIntro from '../../../../lib/introJs/intros/profile/profile';
import PreferredUnits from './form/PreferredUnits';
import DeleteAccountInfo from '../components/DeleteAccountInfo';
// import CloseAccountInfo from '../components/CloseAccountInfo';
import InlineSpinner from '../../../common/InlineSpinner';
import ManageConnections from './ManageConnections.vue';


export default {
  name: 'profile',
  components: {
    PreferredUnits,
    AppContainer,
    TeamForm,
    MemberGender,
    MemberHeight,
    MemberWeight,
    MemberBirthDate,
    MemberLastName,
    MemberFirstName,
    ErrorDisplay,
    InformationIcon,
    DeleteAccountInfo,
    // CloseAccountInfo,
    InlineSpinner,
    ManageConnections,
  },
  props: [
    'member_id',
  ],
  data: function data() {
    return {
      clicked: null,
      member: {},
      team: {},
      updating: false,
      show: false,
      showForm: true,
      error: null,
      isGarmin: false,
      step: 1,
      modalTitle: 'Link Your Device',
      disableClose: false,
      garminDevice: this.$container.deviceFactory.create('garmin'),
      suuntoDevice: this.$container.deviceFactory.create('suunto'),
      suuntoV2Device: this.$container.deviceFactory.create('suuntoV2'),
      polarDevice: this.$container.deviceFactory.create('polar'),
      corosDevice: this.$container.deviceFactory.create('coros'),
      appleDevice: this.$container.deviceFactory.create('apple'),
      screenWidth: window.innerWidth,
    };
  },
  async created() {
    await this.initializeComponent();
    this.$container.eventBus.emit('pageMounted', this);
  },
  methods: {
    ...mapActions([
      'updateMember',
      'loadMember',
      'cancelSubscription',
      'signOut',
    ]),
    async initializeComponent() {
      await this.getMemberSetUpdating();
      if (!this.$store.state.user.teams || this.$store.state.user.teams.length < 1) {
        this.showIntro();
      }
    },
    showIntro(forceShow = false) {
      const key = `PwrLab:Intro:ProfileIntro:${this.member.memberId}`;
      const options = profileIntro(this.$refs);
      IntroUtils.showIntroIfNecessary(options, key, forceShow);
    },
    getMember(setUpdating = false) {
      if (setUpdating) {
        this.updating = true;
        this.error = null;
      }
      // Clone the user, otherwise form changes will propagate
      // to the user object before they are saved.
      this.member = cloneDeep(this.loggedInMember);
      if (this.loggedInMember.teams && this.loggedInMember.teams.length > 0) {
        this.team = cloneDeep(this.loggedInMember.teams[0]);
      }
      if (setUpdating) {
        this.updating = false;
      }
    },
    getMemberSetUpdating() {
      this.getMember(true);
    },
    async updateUser() {
      try {
        this.updating = true;
        await this.$store.commit('updateMember', this.member);
        await this.$container.memberService.syncMember();
        this.getMember();
      } catch (error) {
        this.error = error;
      } finally {
        this.updating = false;
      }
    },
    saveToDb() {
      if (!this.$refs.form.isValid) {
        return;
      }

      this.updateUser();
      this.setShow();
    },
    cancelSave() {
      this.getMemberSetUpdating();
      this.$refs.form.resetValidation();
      this.$nextTick(() => { this.showForm = true; });
    },
    setShow() {
      this.show = true;
      setTimeout(() => {
        this.show = false;
      }, 4000);
    },
    async saveTeam() {
      try {
        this.updating = true;
        await this.$container.dao.saveTeam(this.team);
        this.$store.state.user.teams[0].athletes_can_view_dashboard = this
          .team.athletes_can_view_dashboard;
      } catch (e) {
        this.error = e;
      } finally {
        this.updating = false;
      }
    },
    async closeAccount() {
      if (await this.confirmation({
        message: `
          <div>
            <p class="h3 mb-4">Close Account</p>
            <p class="text-muted text-left">
              <small>
                Any active subscriptions or trials will be canceled. You will lose access to paid features of the Training App.
              </small>
            </p>
            <p class="text-left text-muted">
              <small><strong class="text-dark">You will still be able to</strong> passively send data to Connected Event Leaderboards or Brand Programs that you are in (or join in the future). You may reactivate a subscription or trial at any time, and restore previously reported data.</small>
            </p>
            <span class="h3">Are you sure?</span>
          </div>
        `,
      })) {
        try {
          this.clicked = 'close';
          this.updating = true;
          await this.cancelSubscription(this.member.memberId);
          this.subscriptionCanceled = true;
          await this.loadMember(this.member.memberId);
        } catch (err) {
          this.updating = false;
          this.error = err;
        } finally {
          this.$refs.confirmCloseAccountModalRef.show();
          this.updating = false;
          this.clicked = null;
        }
      }
    },
    async deleteAccount() {
      if (await this.confirmation({
        message: `
          <div>
            <p class="h3 mb-4">Delete Account</p>
            <p class="text-black text-left">
              <small class="text-muted">
                Your PWR Lab account will be deleted. Deleted data will not be retrievable. <strong class="text-dark">This action is permanent, and cannot be undone.<strong>
              </small>
            </p>
            <span class="h3">Are you sure?</span>
          </div>
        `,
      })) {
        try {
          this.clicked = 'delete';
          this.updating = true;
          await this.$api.optOut(this.loggedInMember);
          await this.$container.dao.deleteAccount(this.member.memberId);
          await this.signOut();
          await this.$router.push({
            name: 'login',
          });
        } catch (err) {
          this.updating = false;
          this.error = err;
        }
      }
    },
    closeAccountConfirmed() {
      this.$refs.confirmCloseAccountModalRef.hide();
    },
  },
  computed: {
    ...mapGetters([
      'loggedInMember',
    ]),
    showLinkDevices() {
      return true;
    },
    showBirthDate() {
      return true;
    },
    showBiometrics() {
      return true;
    },
    showSex() {
      return true;
    },
    showTeam() {
      return this.loggedInMember.memberType === 'Coach';
    },
    teamIsVisible() {
      return this.loggedInMember.teams.length > 0 && this.loggedInMember.teams[0].team_data_visible;
    },
    teamLink() {
      return `${window.location.protocol}//${window.location.hostname}/signup/team/${this.team.team_id}`;
    },
    isMobileWidth() {
      return this.screenWidth < 435;
    },
  },
};
